import { render, staticRenderFns } from "./role_d.vue?vue&type=template&id=8e2ec4f0&scoped=true"
import script from "./role_d.vue?vue&type=script&lang=js"
export * from "./role_d.vue?vue&type=script&lang=js"
import style0 from "./role_d.vue?vue&type=style&index=0&id=8e2ec4f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2ec4f0",
  null
  
)

export default component.exports